module.exports = __webpack_public_path__ + "static/media/test4.8f6617e0.png";